import { motion } from "framer-motion";
import { useEffect, useRef } from "react";
import { useFormContext } from "../context/FormContextProvider";
import {
  pageVariants,
  containerVariants,
  itemVariants,
} from "../data/variants";

const Results = ({ resultPara }: { resultPara: string }) => {
  const { formData, setTab, sendBookingToCrm } = useFormContext();
  console.log(formData);

  // Prefill Calendly so the booking lands on the same CRM contact as the form.
  const calendlyParams = new URLSearchParams({
    hide_event_type_details: "1",
    hide_gdpr_banner: "1",
    name: `${formData.firstName} ${formData.lastName}`.trim(),
    email: formData.email,
  });
  const calendlyUrl = `https://calendly.com/el3vn-team/el3vn-intro-call-20-min?${calendlyParams
    .toString()
    .replace(/\+/g, "%20")}`;

  // Calendly tells the page when they book; pass it to the CRM (once per booking).
  const reportedBookings = useRef(new Set<string>());
  useEffect(() => {
    const onMessage = (e: MessageEvent) => {
      if (e.origin !== "https://calendly.com" || e.data?.event !== "calendly.event_scheduled") return;
      const inviteeUri = e.data.payload?.invitee?.uri;
      if (typeof inviteeUri !== "string" || reportedBookings.current.has(inviteeUri)) return;
      reportedBookings.current.add(inviteeUri);
      sendBookingToCrm(inviteeUri);
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [sendBookingToCrm]);

  // Load Calendly script
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Clean up script if component unmounts
      const existingScript = document.querySelector(
        'script[src="https://assets.calendly.com/assets/external/widget.js"]'
      );
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  // Note: Form data is NOT automatically cleared to allow testing resubmission
  // Data is only cleared when user explicitly clicks "Start Over"

  return (
    <motion.div
      className="results"
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <motion.div
        variants={containerVariants}
        initial="initial"
        animate="animate"
        className="results__content"
      >
        <div className="results__layout">
          <motion.div variants={itemVariants} className="results__text-column">
            <h1 className="results__title">
              <span className="results__title-text">
                Thank you,{" "}
                {formData.firstName ? (
                  <span className="question__highlight">
                    {formData.firstName}
                  </span>
                ) : (
                  <span className="question__highlight">there</span>
                )}
                !
              </span>
            </h1>

            <div className="results__description">
              <p className="result__para">
                The next step is to schedule a 20-minute Intro Call so we can
                get you information on getting started on earning up to{" "}
                <strong>$1,000 / month in Passive Income!</strong>
              </p>
            </div>
          </motion.div>

          <div className="results__calendly-column">
            <div
              className="calendly-inline-widget"
              data-url={calendlyUrl}
              style={{
                minWidth: "500px",
                minHeight: "620px",
              }}
            ></div>
          </div>
        </div>
        {/* Test button positioned inline with name */}
        <motion.button
          className="button test-button-inline"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => {
            // Go back to Question 11 for testing without clearing data
            setTab(11);
          }}
          style={{
            backgroundColor: "#10b981",
            borderColor: "#10b981",
            fontSize: "0.875rem",
            padding: "0.5rem 1rem",
            verticalAlign: "middle",
          }}
        >
          <span>👈 Go Back & Resubmit</span>
        </motion.button>
      </motion.div>
    </motion.div>
  );
};

export default Results;
